export default "__VITE_ASSET__af937f1e__"